import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=7c54e90f&scoped=true"
import script from "./addCategory.vue?vue&type=script&lang=js"
export * from "./addCategory.vue?vue&type=script&lang=js"
import style0 from "./addCategory.vue?vue&type=style&index=0&id=7c54e90f&prod&scoped=true&lang=css"
import style1 from "./addCategory.vue?vue&type=style&index=1&id=7c54e90f&prod&lang=css"
import style2 from "./addCategory.vue?vue&type=style&index=2&id=7c54e90f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54e90f",
  null
  
)

export default component.exports